var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"subscription-alert px-3 py-1 m-0",class:_vm.roundedClass},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }